import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class UpdateStatusService {
    private outOfSync$ = new BehaviorSubject<boolean>(false);

    setOutOfSync(value: boolean) {
        this.outOfSync$.next(value);
    }

    isOutOfSync() {
        return this.outOfSync$.asObservable();
    }

    getOutOfSyncValue(): boolean {
        return this.outOfSync$.value;
    }
}
